import { Clock, Instagram, MapPin, Phone } from "lucide-react";
import { txt } from "@/lib/format";

const Row = ({ icon: Icon, children, testid }) => (
  <div className="flex items-start gap-2 text-sm text-[var(--wt-muted)]" data-testid={testid}>
    <Icon className="mt-0.5 h-4 w-4 shrink-0" style={{ color: "var(--wt-primary)" }} />
    <span className="break-words">{children}</span>
  </div>
);

export const MenuFooter = ({ s, lang, t }) => {
  const f = s.footer;
  const name = txt(s.brand, "name", lang);
  if (!f.enabled) return null;
  const handle = (f.instagram || "").replace(/^@/, "");
  return (
    <footer data-testid="menu-footer" className="mt-12 border-t" style={{ borderColor: "color-mix(in srgb, var(--wt-text) 8%, transparent)", background: "var(--wt-surface)" }}>
      <div className="mx-auto grid max-w-6xl gap-6 px-4 py-10 sm:grid-cols-2 sm:px-6">
        <div className="space-y-2">
          <div className="text-xl font-black tracking-tight">{name}</div>
          {txt(f, "text", lang) && <p className="max-w-sm text-sm text-[var(--wt-muted)]">{txt(f, "text", lang)}</p>}
        </div>
        <div className="space-y-2.5">
          {txt(f, "address", lang) && <Row icon={MapPin} testid="footer-address">{txt(f, "address", lang)}</Row>}
          {txt(f, "hours", lang) && <Row icon={Clock} testid="footer-hours">{txt(f, "hours", lang)}</Row>}
          {f.phone && <Row icon={Phone} testid="footer-phone"><a href={`tel:${f.phone.replace(/\s/g, "")}`} dir="ltr" className="hover:underline">{f.phone}</a></Row>}
          {handle && <Row icon={Instagram} testid="footer-instagram"><a href={`https://instagram.com/${handle}`} target="_blank" rel="noreferrer" dir="ltr" className="hover:underline">@{handle}</a></Row>}
        </div>
      </div>
      <div className="pb-6 text-center text-xs text-[var(--wt-muted)]">© {new Date().getFullYear()} {name}. {t("pub.rights")}</div>
    </footer>
  );
};
